export { default } from './HoldsQuotasPopOver';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsQuotasPopOver/index.js